import React from 'react';
import { useTranslation } from 'react-i18next';
import FadeInSection from './FadeInSection';

const TechSection: React.FC = () => {
  const { t } = useTranslation('website');

  const techItems = t('tech.items', { returnObjects: true }) as Array<{ title: string; desc: string }>;
  const icons = ['layers', 'bot', 'server', 'share-2', 'target', 'cpu'];
  const iconColors = ['text-accent-400', 'text-primary-400', 'text-primary-400', 'text-accent-400', 'text-primary-400', 'text-primary-400'];

  return (
    <section id="tech" className="py-24 lg:py-32 relative section-alt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <FadeInSection className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-8 h-[2px] bg-accent-500" />
            <span className="text-accent-400 text-xs font-semibold tracking-wider uppercase">{t('tech.label')}</span>
            <div className="w-8 h-[2px] bg-accent-500" />
          </div>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-4">{t('tech.title')}</h2>
          <p className="text-dark-400 max-w-2xl mx-auto" style={{ lineHeight: '1.9' }}>{t('tech.subtitle')}</p>
        </FadeInSection>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {techItems.map((item, i) => (
            <FadeInSection key={i} delay={`fade-in-delay-${(i % 3)}` as any} className="card-hover p-8 rounded-2xl bg-dark-900/40 border border-dark-800/50">
              <div className="tech-icon mb-5">
                <i data-lucide={icons[i]} className={`${iconColors[i]} text-4xl`} />
              </div>
              <h3 className="text-lg font-semibold text-white mb-3">{item.title}</h3>
              <p className="text-dark-400 text-sm" style={{ lineHeight: '1.8' }}>{item.desc}</p>
            </FadeInSection>
          ))}
        </div>

        {/* Footer text */}
        <FadeInSection delay="fade-in-delay-4" className="mt-10 text-center">
          <p className="text-dark-500 text-sm">{t('tech.footer')}</p>
        </FadeInSection>
      </div>
    </section>
  );
};

export default TechSection;
